<template>
	<b-collapse v-model="showFilters">
		<div class="well well-filter" style="margin-bottom:30px;">
			<div class="form-group">
				<div class="row">
					<div class="col-xs-12 col-sm-6 col-md-4">
						<h4 class="h4 white">Sort</h4>
						<div class="filter-input-margin">
							<label class="form-label sr-only" for="FilterSort">Sort by</label>
							<template v-if="sortOptions && sortOptions.length > 0">
								<b-multi-select
									v-model="selectedSortOrder"
									:options="sortOptions"
									:limit="1"
									class="multi-select"
									placeholder="Sort by"
									block
								/>
							</template>
						</div>
					</div>
					<template v-if="filterOptions">
						<div class="col-xs-12 col-sm-12 col-md-8">
							<h4 class="h4 white">Filter</h4>
							<div class="row">
								<template v-if="filterOptions.regions && filterOptions.regions.length > 0">
									<div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										<label class="form-label sr-only" for="FilterLocation">Country/Region</label>
										<b-multi-select
											v-model="selectedFilters.regions"
											:options="filterOptions.regions"
											class="multi-select"
											placeholder="Country/Region"
											filterable
											block
											collapse-selected
										/>
									</div>
								</template>
								<template v-if="filterOptions.status && filterOptions.status.length > 0">
									<div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										<label class="form-label sr-only" for="FilterStatus">Status</label>
										<b-multi-select
											v-model="selectedFilters.status"
											:options="filterOptions.status"
											class="multi-select"
											placeholder="Status"
											filterable
											block
										/>
									</div>
								</template>
							</div>
							<div class="row">
								<template v-if="filterOptions.dates && filterOptions.dates.length > 0">
									<div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										<label class="form-label sr-only" for="FilterYear">Year</label>
										<b-multi-select
											v-model="selectedFilters.dates"
											:options="filterOptions.dates"
											class="multi-select"
											placeholder="Year"
											filterable
											block
											collapse-selected
										/>
									</div>
								</template>
								<template v-if="filterOptions.tags && filterOptions.tags.length > 0">
									<div div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										<label class="form-label sr-only" for="FilterIssue">Type of issue</label>
										<b-multi-select
											v-model="selectedFilters.tags"
											:options="filterOptions.tags"
											class="multi-select"
											placeholder="Type of issue"
											filterable
											block
											collapse-selected
										/>
									</div>
								</template>
							</div>
						</div>
					</template>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-6 col-sm-offset-6">
						<div class="filter-well-btn-bottom">
							<div class="row">
								<div class="col-xs-6">
									<b-btn
										class="btn btn-primary btn-sm btn-block"
										@click="resetFilters"
									>Reset</b-btn>
								</div>
								<div class="col-xs-6">
									<b-btn
										class="btn btn-secondary btn-sm btn-block"
										@click="applyFilters"
									>Submit</b-btn>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-collapse>
</template>

<script>

export default {
	props: {
		showFilters: {
			type: Boolean,
			required: true
		},
		filterOptions: {
			type: Object,
			default: () => ([])
		},
		sortOptions: {
			type: Array,
			default: () => ([])
		},
		selectedFilters: {
			regions: {
				type: Array,
				default: () => ([])
			},
			status: {
				type: Array,
				default: () => ([])
			},
			tags: {
				type: Array,
				default: () => ([])
			},
			dates: {
				type: Array,
				default: () => ([])
			}
		}
	},
	data() {
		return {
			selectedSortOrder: [],
		};
	},
	methods: {
		resetFilters() {
			this.$emit('selectedOptions', {
				selectedSortOrder: [],
				selectedFilters: {
					regions: [],
					status: [],
					tags: [],
					dates: []
				},
			});
			this.$emit('resetSearchTerm');
			this.$router.push({
				query: null
			});
		},
		applyFilters() {
			this.$emit('selectedOptions', {
				selectedSortOrder: this.selectedSortOrder[0] || null,
				selectedFilters: this.selectedFilters,
			});
		}
	}
};
</script>
